import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAgreementGate } from './useAgreementGate';
import { agreementCopy } from './agreementCopy';

/**
 * Top-of-page notice on every page: e-sign pending (locked), expiring soon, renewal due, or the
 * renewal date passed. Only pending locks anything; the rest are reminders.
 */
const AgreementBanner: React.FC = () => {
  const { status, validUntil, renewBy, esignEnabled } = useAgreementGate();
  const { pathname } = useLocation();

  const copy = esignEnabled ? agreementCopy(status, validUntil, renewBy) : null;
  if (!copy?.banner || pathname.startsWith('/agreement')) {
    return null;
  }

  return (
    <div
      className={`flex flex-col sm:flex-row sm:items-center justify-between gap-3 max-w-7xl mx-auto mt-4 px-5 py-3 rounded-xl border ${
        copy.urgent ? 'bg-amber-50 border-amber-200' : 'bg-stone-100 border-stone-200'
      }`}
    >
      <p className="text-sm font-medium text-stone-800">{copy.banner}</p>
      <Link
        to="/agreement"
        className="shrink-0 text-center h-9 leading-9 rounded-lg px-4 text-sm font-semibold text-white bg-green-700"
      >
        {copy.action}
      </Link>
    </div>
  );
};

AgreementBanner.displayName = 'AgreementBanner';

export default AgreementBanner;
